import { Component } from '@angular/core';

@Component({
  selector: 'app-pack-minimal',
  imports: [],
  templateUrl: './pack-minimal.component.html',
  styleUrl: './pack-minimal.component.css'
})
export class PackMinimalComponent {

}
